import { FC, useEffect } from 'react';

import { useVideoContext } from '../../VideoController/VideoController.context';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';
import { useGetStartedContext } from '../../../Shared/GetStarted/GetStarted.context';

import { Content } from '../../../../types/tour';

const codeSample = () => `
export const UI = () => {
  return (
    <>
      <PaginatedGridLayout />
      <MyCallControls />
    </>
  );
};


export const MyCallControls = ({ onLeave }: CallControlsProps) => (
  <div className="str-video__call-controls">
    <SpeakingWhileMutedNotification>
      <ToggleAudioPublishingButton />
    </SpeakingWhileMutedNotification>
    <ToggleVideoPublishingButton />
    <CancelCallButton onLeave={onLeave} />
  </div>
);
`;
export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
  step: number;
};

export const Step5: FC<Props> = ({ setComplete, content }) => {
  const { setCustomControls } = useVideoContext();
  const { state: getStartedState } = useGetStartedContext();

  const run = async () => {
    setComplete();
    setCustomControls(true);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code
          language="jsx"
          footer={{
            label: 'Run Code',
            disabled: getStartedState.steps[getStartedState.current].completed,
            run,
          }}
        >
          {codeSample()}
        </Code>
      }
    />
  );
};
